import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
	state:{
		routes:[],
		tabs:[],
		route:null,
		sites:[],
		siteId:null,
		siteName:null
		
	},
	mutations:{
		initRoutes(state,data){
			state.routes=data;
		},
		initabs(state,data){
			state.tabs=data;
		},
		initSites(state,data){
			state.sites=data;
		},
		initSiteId(state,data){
			state.siteId=data;
		},
		initSiteName(state,data){
			state.siteName=data;
		},
		
	},
	actions:{
		
	}
})
